module.exports = __webpack_public_path__ + "img/cisco-1.3b6c95c5.webp";